import React from 'react';

import { CommonProps, mosaiqStyled } from '../../lib';
import { Button } from '../Button';
import { OverflowMenu } from '../OverflowMenu';
import { MenuItem } from '../MenuItem';
import { DropdownArrow, FieldPlaceholder } from '../../base';

import { DropdownProps } from './types';

const Dropdown = <T,>({
  value,
  renderValue,
  options = [],
  renderOption,
  placeholder = 'Select',
  startAdornment,
  endAdornment,
  disabled = false,
  locked = false,
  defaultOpen = false,
  placement = 'bottom-start',
  appendTo = 'parent',
  variant = 'secondary',
  onSelectItem,
  closeOnSelect = true,
  menuProps,
  buttonEndAdornment,
  ...props
}: DropdownProps<T> & CommonProps<HTMLButtonElement>) => {
  const enabled = !(disabled || locked);

  return (
    <OverflowMenu
      data-testid="dropDownOverflowMenu"
      appendTo={appendTo}
      disabled={!enabled}
      placement={placement}
      defaultOpen={defaultOpen}
      closeOnSelect={closeOnSelect}
      menuProps={menuProps}
      opener={({ isOpen }) => (
        <Button
          data-testid="dropDownBtn"
          active
          disabled={disabled}
          variant={variant}
          startAdornment={startAdornment}
          endAdornment={
            buttonEndAdornment === undefined ? (
              <DropdownArrow open={isOpen} locked={locked} />
            ) : (
              buttonEndAdornment
            )
          }
          {...props}
        >
          <span>
            {value !== undefined && value !== null ? (
              typeof value === 'string' && !renderValue ? (
                value
              ) : (
                renderValue?.(value as T)
              )
            ) : (
              <FieldPlaceholder>{placeholder}</FieldPlaceholder>
            )}
          </span>
          {endAdornment}
        </Button>
      )}
    >
      {options.map((option, i) =>
        typeof option === 'string' && !renderOption ? (
          <MenuItem
            size="small"
            key={typeof option === 'string' ? option : i}
            tabIndex={i}
            primaryText={option}
            primaryTextProps={{ fontWeight: 500 }}
            onClick={() => onSelectItem?.(option)}
          />
        ) : (
          renderOption?.(option, i)
        ),
      )}
    </OverflowMenu>
  );
};

export default mosaiqStyled(Dropdown) as typeof Dropdown;
